<script setup lang="ts">
import {computed, onMounted, onUnmounted} from 'vue';
import {RouterView, useRoute} from 'vue-router';
import {BarChart3, ChartLine, ClipboardList, Wrench} from 'lucide-vue-next';
import {AvailabilityState} from 'common';
import AppShell from '@/views/shell/AppShell.vue';
import {type NavItem} from '@/views/shell/navItems.js';
import {numHedenReady, numHedenTodo} from '@/base/reporter.js';
import {fetchAndSetState, startStatePolling, stateForReporters, stopStatePolling} from '@/base/TMP_globalState.js';
import {done, loadingState, reload} from '@/base/loadingState.js';
import LoadingStateView from '@/views/general/LoadingStateView.vue';

const route = useRoute();

// the dashboard is available while the site is closed for reporting, so it must not be hidden behind the closed check below
const onDashboard = computed<boolean>(() => route.path.startsWith('/report/dashboard'));

const items = computed<NavItem[]>(() => [
    ...(stateForReporters.value !== AvailabilityState.closed ? [
        {label: 'rapporteren', to: '/report/rapporteren', icon: ClipboardList, badge: numHedenReady.value, badgeColor: 'green', badgeExtra: numHedenTodo.value, badgeExtraColor: 'orange'},
        {label: 'al mijn KPIs', to: '/report/al-mijn-kpis', icon: ChartLine},
        {label: 'beheer', to: '/report/beheer', icon: Wrench},
    ] as NavItem[] : []),
    {label: 'dashboard', to: '/report/dashboard', icon: BarChart3, exact: false},
]);

onMounted(async () => {
    await reload();
    await fetchAndSetState();
    startStatePolling();
});

onUnmounted(() => {
    stopStatePolling();
});
</script>

<template>
    <AppShell landing="Rapportage" :items="items">
        <LoadingStateView :state="loadingState" :stateForReporters="onDashboard ? AvailabilityState.read : stateForReporters"/>
        <RouterView v-if="done && (stateForReporters !== AvailabilityState.closed || onDashboard)"/>
    </AppShell>
</template>
